import organizersService from "../../../services/organizersService";
import eventsService from "../../../services/eventsService";
import moment from "moment";
import rules from "../../../utils/utils";
import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import { mapGetters } from "vuex";
export default {
  name: "eventreport",
  components: { pageheader },
  props: [],
  data() {
    return {
      input: {},
      rules: rules.getRules(),
      downloading: false,
      menu1: false,
      menu2: false,
      fromDate: "",
      toDate: "",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      status: [
        {
          id: 2,
          name: "All"
        },
        {
          id: 0,
          name: "Open"
        },
        {
          id: 1,
          name: "Cancelled"
        }
      ],
      events: [],
      event: [],
      organizersList: [],
      selectedUsers: [],
      selectedEvents: [],
      selectedEventStatus: 2,
      transactionId: "",
      showDetailsDialog: false,
      reporteventDate: null,
      reportorganizer: null,
      reportteam: null,
      reportattendee: null,
      reportattendeeEmail: null,
      reportattendeeTimeZone: null,
      reportlocation: null,
      reportcancelled: null,
      reportcancelReason: null,
      reporteventtype: null,
      reporteventtimeslot: null,
      reportReferenceID: null,
      reportNotes: null,
      appointmentReports: [],
      loading: false,
      reportattendeeList: [],
      hasReportData: false,
      openedPanel: [],
      isExpanded: false,
      showbanner:true
    };
  },
  filters: {
    lowercase: function(value) {
      if (value) {
        return value.toLowerCase();
      }
    },
  },
  computed: {
    ...mapGetters(["roles"]),
    selectAllUsers() {
      return this.selectedUsers.length === this.organizersList.length;
    },
    selectSomeUsers() {
      return this.selectedUsers.length > 0 && !this.selectAllUsers;
    },
    icon() {
      if (this.selectAllUsers) return "mdi-close-box";
      if (this.selectSomeUsers) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    selectAllEvents() {
      return this.selectedEvents.length === this.events.length;
    },
    selectSomeEvents() {
      return this.selectedEvents.length > 0 && !this.selectAllEvents;
    },
    eventicon() {
      if (this.selectAllEvents) return "mdi-close-box";
      if (this.selectSomeEvents) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    selectAllStatus() {
      return this.selectedEventStatus.length === this.status.length;
    },
    selectSomeStatus() {
      return this.selectedEventStatus.length > 0 && !this.selectAllStatus;
    },
    statusIcon() {
      if (this.selectAllStatus) return "mdi-close-box";
      if (this.selectSomeStatus) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  mounted() {
    this.input = utils.getInputContent("eventreport", this.roles);
    this.getOrganizersList();
    this.getEvents();
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.selectAllUsers) {
          this.selectedUsers = [];
        } else {
          this.selectedUsers = this.organizersList.slice();
        }
      });
    },
    eventToggle() {
      this.$nextTick(() => {
        if (this.selectAllEvents) {
          this.selectedEvents = [];
        } else {
          this.selectedEvents = this.events.slice();
        }
      });
    },
    statusToggle() {
      this.$nextTick(() => {
        if (this.selectAllStatus) {
          this.selectedEventStatus = [];
        } else {
          this.selectedEventStatus = this.status.slice();
        }
      });
    },
    getOrganizersList() {
      organizersService.getOrganizers(
        this,
        response => {
          if (response.length > 0) {
            //sort array based on email
            response.sort(function(a, b) {
              let emailA = a.email.toUpperCase(); // ignore upper and lowercase
              let emailB = b.email.toUpperCase(); // ignore upper and lowercase
              if (emailA < emailB) {
                return -1;
              }
              if (emailA > emailB) {
                return 1;
              }
              // names must be equal
              return 0;
            });
            this.organizersList = response;
          }
        },
        error => {
          console.log(error);
          this.$toast.error("unable to get organizers. Please try again later");
        }
      );
    },
    getEvents() {
      eventsService.getEvents(
        this,
        response => {
          if (response.length > 0) {
            //sort array based on title
            response.sort(function(a, b) {
              let titleA = a.title.toUpperCase(); // ignore upper and lowercase
              let titleB = b.title.toUpperCase(); // ignore upper and lowercase
              if (titleA < titleB) {
                return -1;
              }
              if (titleA > titleB) {
                return 1;
              }
              // names must be equal
              return 0;
            });
            this.events = response;
          }
          this.showloadingSection = false;
        },
        error => {
          console.log(error);
          this.showloadingSection = false;
          this.$toast.error(
            "Unable to get events at the moment. Please try again later"
          );
        }
      );
    },
    getReport() {
      if (this.dateValidation()) {
        //clear the existing response
        this.appointmentReports = [];
        let users =
          this.selectedUsers.length == this.organizersList.length
            ? ""
            : this.selectedUsers.toString();
        let types =
          this.selectedEvents.length == this.events.length
            ? ""
            : String(this.selectedEvents);
        let reportStatus =
          this.selectedEventStatus == 2 ? "" : String(this.selectedEventStatus);
        let payload = `fromDate=${this.fromDate}&toDate=${this.toDate}&users=${users}&eventType=${types}&status=${reportStatus}&referenceId=${this.transactionId}`;
        this.loading = true;
        eventsService.getReportData(
          this,
          payload,
          response => {
            this.appointmentReports = response.appointmentReports;
            this.hasReportData = true;
            this.appointmentReports.map(item => {
              item.appointmentDate = moment(item.appointmentDate).format(
                "MM/DD/YYYY"
              );
              item.appointmentDateFormatted = moment(
                item.appointmentDate
              ).format("dddd, MMMM Do YYYY");
              item.appointmentReport.map(appointmentReportItem => {
                appointmentReportItem.timeslot =
                  moment(appointmentReportItem.startDateTime).format(
                    "hh:mm A"
                  ) +
                  " - " +
                  moment(appointmentReportItem.endDateTime).format("hh:mm A");
              });
            });
            this.loading = false;
          },
          error => {
            this.$toast.error(error);
            this.loading = false;
          }
        );
      }
    },
    dateValidation() {
      const date1 = moment(this.fromDate).format("YYYY-MM-DD");
      const date2 = moment(this.toDate).format("YYYY-MM-DD");
      if (date1 > date2) {
        this.$toast.error("From date should be less than or equal to End date");
        return false;
      }
      // else if (
      //   date1 == "" ||
      //   date2 == "" ||
      //   date1 == "Invalid date" ||
      //   date2 == "Invalid date"
      // ) {
      //   this.$toast.error("Please select From/End Dates");
      //   return false;
      // }
      else {
        return true;
      }
    },
    download() {
      if (this.dateValidation()) {
        let users =
          this.selectedUsers.length == this.organizersList.length
            ? ""
            : this.selectedUsers.toString();
        let types =
          this.selectedEvents.length == this.events.length
            ? ""
            : this.selectedEvents.toString();
        let reportStatus =
          this.selectedEventStatus == 2
            ? ""
            : this.selectedEventStatus.toString();
        let payload = `&fromDate=${this.fromDate}&toDate=${this.toDate}&users=${users}&eventType=${types}&status=${reportStatus}&referenceId=${this.transactionId}`;
        this.downloading = true;
        eventsService.downloadReport(
          this,
          payload,
          response => {
            this.downloadFile(response);
            this.downloading = false;
          },
          error => {
            console.log(error);
            this.downloading = false;
            this.$toast.error("Unable to download the attachment");
          }
        );
      }
    },
    downloadFile(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]), {
        type: "application/vnd.ms-excel"
      });
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Events Report.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    viewEventDetails(reportItem, index) {
      if (reportItem) {
        this.reporteventDate = reportItem.appointmentDate;
        this.reportorganizer = reportItem.appointmentReport[index].userName;
        this.reportteam = reportItem.appointmentReport[index].team;
        this.reportattendeeList = reportItem.appointmentReport[index].invitees;
        this.reportattendee = reportItem.appointmentReport[index].inviteeName;
        this.reportattendeeEmail =
          reportItem.appointmentReport[index].inviteeEmail;
        this.reportattendeeTimeZone =
          reportItem.appointmentReport[index].timezone;
        this.reportlocation = reportItem.appointmentReport[index].location;
        this.reportcancelled = reportItem.appointmentReport[index].canceled;
        this.reportcancelReason =
          reportItem.appointmentReport[index].cancellationReason;
        this.reporteventtype =
          reportItem.appointmentReport[index].eventTypeName;
        this.reporteventtimeslot = reportItem.appointmentReport[index].timeslot;
        this.reportReferenceID =
          reportItem.appointmentReport[index].referenceId;
        this.reportNotes = reportItem.appointmentReport[index].notes;

        this.showDetailsDialog = true;
      }
    },
    cancelClick() {
      this.$refs.searchReportForm.reset();
      this.$refs.searchReportForm.resetValidation();
      this.fromDate = "";
      this.toDate = "";
      this.transactionId = "";
      this.selectedEventStatus = 2;
    },
    handleToggle() {
      if (this.isExpanded) {
        this.openedPanel = [0];
        this.showbanner = false;
      } else {
        this.openedPanel = [1];
        this.showbanner = true;
      }
    },
    toggleClick() {
      this.isExpanded = !this.isExpanded;
      this.handleToggle();
    },
    openModal() {
      this.$refs.modal.showModal();
    },
  }
};
